import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";

import { Tooltip } from "@mui/material";
import { FaGraduationCap } from "react-icons/fa6";
import {
  ActiveInactiveCoreService,
  deleteCoreService,
  getAllCoreServices,
} from "./services/coreServices.services";
import { clearCoreServiceID, setCoreServiceID } from "./coreServicesSlice";

const CoreService: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllCoreServices());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const handleCreate = () => {
    navigate("/coreservice/create");
  };

  return (
    <React.Fragment>
      <DeleteCoreServiceDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Core Services List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Create Core Service
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <CoreServiceGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </React.Fragment>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const CoreServiceGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const CoreServiceList = useAppSelector(
    (state) => state.coreservice.CoreServiceList
  );
  const loading = useAppSelector((state) => state.coreservice.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? CoreServiceList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (ID: number) => {
      navigate("/coreservice/edit", { state: { CoreServiceID: ID } });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteCoreServiceDialog"));
      dispatch(setCoreServiceID(ID));
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            themeColor="success"
            size="small"
            title="Edit"
            onClick={() => handleEdit(props.dataItem.ID)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 3 || props.index === 4 || props.index === 2
          ? "locked-header"
          : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: any) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveCoreService(data)).then(() => {
        dispatch(getAllCoreServices());
        // if (response.payload?.data?.Status === 200) {
        //   dispatch(getAllBankes());
        // } else {
        //   dispatch(getAllBankes());
        // }
      });
    };

    return (
      <td
        className={`${props.className}`}
        style={{ ...props.tdProps.style, textAlign: "center" }}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <React.Fragment>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {CoreServiceList && CoreServiceList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          className="responsive-table"
          filter={filter}
          data={
            filter
              ? filterBy(CoreServiceList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : CoreServiceList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={CoreServiceList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="CoreService"
            title="Core Service Name"
            width={300}
            cells={{
              data: (props: any) => (
                <td>
                  {isEditAccess ? (
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/coreservice/edit", {
                          state: { CoreServiceID: props.dataItem?.ID },
                        })
                      }
                    >
                      {props.dataItem?.CoreService}
                    </div>
                  ) : (
                    <div className="normalName">
                      {props.dataItem?.CoreService}
                    </div>
                  )}
                </td>
              ),
            }}
          />
          <Column field="ServiceName" title="Service Name" width={300} />
          <Column
            field="MainImage"
            title="Image"
            width={110}
            locked={true}
            filterable={false}
            cells={{
              data: (props: any) => (
                <td
                  className={`${props.className}`}
                  style={{ ...props.tdProps.style, textAlign: "center" }}
                >
                  <Tooltip
                    title={
                      <img
                        src={props.dataItem?.MainImage}
                        alt="service-image"
                        width={250}
                        onClick={() => window.open(props.dataItem?.MainImage)}
                        height={250}
                      />
                    }
                  >
                    {props.dataItem?.MainImage ? (
                      <img
                        style={{ border: "1px solid grey", padding: "1px" }}
                        src={props.dataItem?.MainImage}
                        alt="service-image"
                        width={50}
                        onClick={() => window.open(props.dataItem?.MainImage)}
                        height={50}
                      />
                    ) : (
                      <FaGraduationCap
                        style={{
                          fontSize: "50px",
                          background: "lightgray",
                          padding: "5px",
                          borderRadius: "4px",
                          color: "#163064",
                        }}
                      />
                    )}
                  </Tooltip>
                </td>
              ),
            }}
          />
          <Column
            field="IconImage"
            title="Icon Image"
            width={110}
            locked={true}
            filterable={false}
            cells={{
              data: (props: any) => (
                <td
                  className={`${props.className}`}
                  style={{ ...props.tdProps.style, textAlign: "center" }}
                >
                  <Tooltip
                    title={
                      <img
                        src={props.dataItem?.IconImage}
                        alt="service-image"
                        width={250}
                        onClick={() => window.open(props.dataItem?.IconImage)}
                        height={250}
                      />
                    }
                  >
                    {props.dataItem?.IconImage ? (
                      <img
                        style={{ border: "1px solid grey", padding: "1px" }}
                        src={props.dataItem?.IconImage}
                        alt="service-image"
                        width={50}
                        onClick={() => window.open(props.dataItem?.IconImage)}
                        height={50}
                      />
                    ) : (
                      <FaGraduationCap
                        style={{
                          fontSize: "50px",
                          background: "lightgray",
                          padding: "5px",
                          borderRadius: "4px",
                          color: "#163064",
                        }}
                      />
                    )}
                  </Tooltip>
                </td>
              ),
            }}
          />

          <Column
            field="ID"
            title="Status"
            cells={{ data: MyActiveInActtiveCommandCell }}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cells={{ data: MyEditCommandCell }}
              width={"110px"}
              filterable={false}
              locked={true}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </React.Fragment>
  );
};

const DeleteCoreServiceDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const CoreServiceID = useAppSelector(
    (state) => state.coreservice.CoreServiceID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteCoreService(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllCoreServices());
        dispatch(closeDialog());
        dispatch(clearCoreServiceID());
      } else {
        dispatch(getAllCoreServices());
        dispatch(closeDialog());
        dispatch(clearCoreServiceID());
      }
    }
  };

  return (
    <React.Fragment>
      {dialogName === "deleteCoreServiceDialog" && (
        <AppDialog>
          <React.Fragment>
            <Typography.h5>{"Delete Core Service"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Core Service ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(CoreServiceID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </React.Fragment>
        </AppDialog>
      )}
    </React.Fragment>
  );
};

export default CoreService;
